import { createAction } from '@reduxjs/toolkit';

const login = createAction('LOGIN');

export { login };
